import { map } from 'rxjs/operators';
import { DataManagerService } from '../../../../../data/services/DataManager/data-manager.service';
import { AppConstants } from '../../../../../shared/constants/app-constants';
import { TopbarSearchResult } from '../../topbar-search.model';
import { SearchProvider } from '../record-search.model';
import { formatUsd, joinParts, listSearch, REDSHIFT_PARAMS, REDSHIFT_TIMEOUT_MS } from './list-search';

/** Taxi merchants list (and open) their charges from a separate endpoint. */
export const TAXI_CHARGES_SERVICE_NAME = '/taxi/charges';

/**
 * Card transactions — GET /charges, or /taxi/charges for TAXI merchants, exactly as
 * PaymentListComponent / PaymentDetailsComponent choose it; searched in Redshift (src=R).
 * Amounts are in cents. Card fields are deliberately never read or shown (PCI).
 * Opens /payment/payment-details?id=<charge id>, as a row click on the list does.
 */
export function chargesProvider(dataManager: DataManagerService): SearchProvider {
  return {
    group: 'Transactions',
    parent: 'payment',
    accepts: () => true,
    // Resolved per search: the user (and merchant type) changes on login / account switch.
    search: query => listSearch(dataManager, chargesServiceName(dataManager), query,
      REDSHIFT_PARAMS, REDSHIFT_TIMEOUT_MS).pipe(
      map(rows => rows.map(toResult).filter(Boolean))
    )
  };
}

function chargesServiceName(dataManager: DataManagerService): string {
  return dataManager.user?.['merchant_type'] === 'TAXI' ? TAXI_CHARGES_SERVICE_NAME : AppConstants.SERVICE_NAME_CHARGE;
}

function toResult(row: any): TopbarSearchResult {
  if (!row?.id) {
    return null;
  }
  const amount = formatUsd(Number(row.amount) / 100);
  return {
    group: 'Transactions',
    label: joinParts(amount, row.charge_description) || String(row.id),
    sublabel: joinParts(row.id, row.status),
    route: ['/payment/payment-details'],
    queryParams: { id: row.id }
  };
}
